import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAdminAuth } from '../context/AdminAuthContext';

interface AdminRouteProps {
  children: React.ReactNode;
  requiredRole?: 'admin' | 'superadmin';
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children, requiredRole }) => {
  const { admin: user, isLoading: loading } = useAdminAuth();

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  // superadmin権限チェック（将来の拡張用）
  if (requiredRole === 'superadmin' && !user.is_superadmin) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;
